import {
  Message
} from 'element-ui'
 
const directive = {
  // 一键复制
  copy:{
    bind (el, { value }) {
      el.$value = value;
      el.handler = async () => {
        console.log(el,'el',value);
        
        if (!el.$value) {
          Message.fail('没有要复制的内容');
          return;
        }
        try {
          // 直接使用 Clipboard API 复制
          await navigator.clipboard.writeText(el.$value);
          Message.success('复制成功');
        } catch (err) {
          // Toast.fail('复制失败', err);
        }
      };
      // 监听点击事件
      el.addEventListener('click', el.handler);
    },
    componentUpdated (el, { value }) {
      el.$value = value;
    },
    unbind (el) {
      el.removeEventListener('click', el.handler);
    }
  }
}
 
export default directive;